import { render, staticRenderFns } from "./CertifikatiJavno.vue?vue&type=template&id=229e972e&"
import script from "./CertifikatiJavno.vue?vue&type=script&lang=js&"
export * from "./CertifikatiJavno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports